import React, { useState, useEffect } from "react";
import "./clientsdashboard.scss";
import DataTable from "./DataTable/DataTable";
import Modal from "react-bootstrap/Modal";
import { Dropdown } from "react-bootstrap";
import { CLAIM_PROJECT_DATA } from "../../../utils/Constants";
import { toast } from "react-toastify";
import { Api_Url } from "../../../utils/ApiUrl";
import useAdminAllowed from "../../../hooks/userManagement/useAdminAllowed";

const Clientsdashboard = () => {
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [toggle1, setToggle1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshTable, setRefreshTable] = useState(0);
  const [checkAdmin, isAdmin] = useAdminAllowed();
  // let isAdmin = false
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    privateSale: "",
    isCsvAllowed: false
  });

  // Form validation errors
  const [errors, setErrors] = useState({});

  const handleClose = () => {
    setShow(false);
    // Reset form when closing
    setFormData({
      name: "",
      email: "",
      privateSale: "",
      isCsvAllowed: false
    });
    setSelectedProject(null);
    setToggle1(false);
    setErrors({});
  };

  const handleShow = () => setShow(true);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const toggleDropdown = (isOpen) => setIsDropdownOpen(isOpen);

  const ApiUrl = Api_Url;

  const handleProjectSelect = (project) => {
    setSelectedProject(project);
    setFormData(prev => ({
      ...prev,
      privateSale: project.value
    }));
    setIsDropdownOpen(false);
    // Clear privateSale error when project is selected
    if (errors.privateSale) {
      setErrors(prev => ({
        ...prev,
        privateSale: ""
      }));
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ""
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.trim().length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email.trim())) {
      newErrors.email = "Please enter a valid email address";
    }

    // Project validation
    if (!formData.privateSale) {
      newErrors.privateSale = "Please select a project";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddClient = async () => {
    if (!validateForm()) {
      // toast.error("Please fix the form errors");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${ApiUrl}/project-admin/add-new/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          email: formData.email.trim(),
          privateSale: formData.privateSale,
          name: formData.name.trim(),
          isCsvAllowed: formData.isCsvAllowed
        })
      });

      const data = await response.json();

      if (response.ok && data.statusCode === 201) {
        // toast.success("Client Dashboard Successfully Added!");
        handleClose();
        handleShow1();
        // Refresh the table data
        setRefreshTable(prev => prev + 1);
      } else {
        // Handle specific error messages from API
        if (data.message) {
          toast.error(data.message);
        } else {
          toast.error("Failed to add client dashboard");
        }
      }
    } catch (error) {
      console.error('Error adding client:', error);
      toast.error("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleChange = (checked) => {
    setToggle1(checked);
    setFormData(prev => ({
      ...prev,
      isCsvAllowed: checked
    }));
  };

  return (
    <>
      <section className="creditprojects">
        <div className="custom-container">
          <div className="topheadings">
            <div className="leftheadings">
              <p className="toppara">Premium Projects</p>
              <h4 className="dashboardhead">Clients Dashboard</h4>
            </div>
            {isAdmin ? <button onClick={handleShow} className="projectbtn">
              Add Client Dashboard
            </button> : null}
          </div>

          <DataTable key={refreshTable} isAdmin={isAdmin}/>
        </div>
      </section>

      <Modal
        show={show}
        onHide={handleClose}
        className="creditmodal newcreditmodal newaddmodal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Client Dashboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <input
              type="text"
              placeholder="Name"
              className={`modalinput ${errors.name ? 'error' : ''}`}
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
            />
            {errors.name && <span className="error-text">{errors.name}</span>}
          </div>

          <div className="form-group">
            <input
              type="email"
              placeholder="User Email"
              className={`modalinput ${errors.email ? 'error' : ''}`}
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <Dropdown show={isDropdownOpen} onToggle={toggleDropdown}>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className={errors.privateSale ? 'error' : ''}
                style={{
                  borderColor: errors.privateSale ? "#dc3545" : (isDropdownOpen ? "#329879" : "transparent"),
                }}
                onClick={() => toggleDropdown(!isDropdownOpen)}
              >
                {!selectedProject ? (
                  <>Project</>
                ) : (
                  <div className="tokeninner">
                    <div className="tokenimg">
                      <img
                        src={selectedProject.imageSrc}
                        alt={selectedProject.label}
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">{selectedProject.label}</p>
                  </div>
                )}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="8"
                  viewBox="0 0 15 8"
                  fill="none"
                  style={{
                    rotate: isDropdownOpen ? "180deg" : "0deg",
                    transition: "rotate 0.3s ease-in-out",
                  }}
                >
                  <path
                    d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                    fill="black"
                  />
                  <path
                    d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
                    fill="black"
                  />
                </svg>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="tokenmain">
                  {CLAIM_PROJECT_DATA.map((project, index) => (
                    <div
                      key={index}
                      className="tokeninner"
                      onClick={() => handleProjectSelect(project)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="tokenimg">
                        <img
                          src={project.imageSrc}
                          alt={project.label}
                          className="innerimg"
                        />
                      </div>
                      <p className="tokenpara">{project.label}</p>
                    </div>
                  ))}
                </div>
              </Dropdown.Menu>
            </Dropdown>
            {errors.privateSale && <span className="error-text">{errors.privateSale}</span>}
          </div>

          <div className="maindownload">
            <div className="downloadheadings">
              <h6 className="downloadhead">CSV downloads</h6>
              <p className="downloadpara">
                Include wallet addresses and transaction hashes.
              </p>
            </div>
            <div className="parent-toggle-switch-custom tabletoggle">
              <div className="custom-toggle">
                <input
                  type="checkbox"
                  className="checkbox"
                  id="toggle-1"
                  checked={toggle1}
                  onChange={(e) => handleToggleChange(e.target.checked)}
                />
                <label className="switch" htmlFor="toggle-1">
                  <span className="slider"></span>
                </label>
              </div>
            </div>
          </div>

          <div className="bottombtns">
            <button className="dullbtn" onClick={handleClose} disabled={loading}>
              Cancel
            </button>
            <button
              onClick={handleAddClient}
              className="greenbtn"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add Client Dashboard"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose1}
        className="creditmodal newcreditmodal newaddmodal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="81"
            viewBox="0 0 80 81"
            fill="none"
            className="tickimg"
          >
            <path
              d="M40 78.3947C60.9286 78.3947 77.8947 61.4286 77.8947 40.5C77.8947 19.5713 60.9286 2.60522 40 2.60522C19.0713 2.60522 2.10522 19.5713 2.10522 40.5C2.10522 61.4286 19.0713 78.3947 40 78.3947Z"
              fill="#329879"
            />
            <path
              d="M36.1262 54.8997C35.5788 54.8997 35.0315 54.6892 34.6525 54.2681L22.9473 42.5629C22.1051 41.7208 22.1051 40.4155 22.9473 39.5734C23.7894 38.7313 25.0946 38.7313 25.9367 39.5734L35.9999 49.6366L54.0209 26.8997C54.7367 25.9734 56.0841 25.8471 56.9683 26.5629C57.8946 27.2787 58.0209 28.626 57.3051 29.5102L37.8104 54.0997C37.4315 54.5629 36.8841 54.8576 36.2946 54.8997C36.2104 54.8997 36.1683 54.8997 36.1262 54.8997Z"
              fill="#E2E9EC"
            />
          </svg>
          <h6 className="successhead m-0">
            Client Dashboard Successfully Added!
          </h6>
          <p className="successpara">
            An email has been sent to the user. They will be able to set their
            password and login to the admin panel using their new password.
          </p>
          <button onClick={handleClose1} className="closebtn">
            Okay
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Clientsdashboard;

// import React, { useState } from "react";
// import "./clientsdashboard.scss";
// import DataTable from "./DataTable/DataTable";
// import Modal from "react-bootstrap/Modal";
// import { Dropdown } from "react-bootstrap";
// import { CLAIM_PROJECT_DATA } from "../../../utils/Constants";
// import { toast } from "react-toastify";
// import { Api_Url } from "../../../utils/ApiUrl";

// const Clientsdashboard = () => {
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const [toggle1, setToggle1] = useState(false);

//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedProject, setSelectedProject] = useState(null);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);
//   const toggleDropdown = (isOpen) => setIsDropdownOpen(isOpen);
// const ApiUrl = Api_Url;
//   const filteredProjects = [
//     { label: "Project A", imageSrc: "projectA.png" },
//     { label: "Project B", imageSrc: "projectB.png" },
//     { label: "Project C", imageSrc: "projectC.png" },
//   ];

//   const handleProjectSelect = (project) => {
//     setSelectedProject(project);
//     setIsDropdownOpen(false);
//   };

//   return (
//     <>
//       <section className="creditprojects">
//         <div className="custom-container">
//           <div className="topheadings">
//             <div className="leftheadings">
//               <p className="toppara">Premium Projects</p>
//               <h4 className="dashboardhead">Clients Dashboard</h4>
//             </div>
//             <button onClick={handleShow} className="projectbtn">
//               Add Client Dashboard
//             </button>
//           </div>

//           <DataTable />
//         </div>
//       </section>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         className="creditmodal newcreditmodal newaddmodal"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Client Dashboard</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <input type="text" placeholder="Name" className="modalinput" />
//           <input type="text" placeholder="User Email" className="modalinput" />
//           <Dropdown show={isDropdownOpen} onToggle={toggleDropdown}>
//             <Dropdown.Toggle
//               variant="success"
//               id="dropdown-basic"
//               style={{
//                 borderColor: isDropdownOpen ? "#329879" : "transparent",
//               }}
//               onClick={() => toggleDropdown(!isDropdownOpen)}
//             >
//               {!selectedProject ? (
//                 <>Project</>
//               ) : (
//                 <div className="tokeninner">
//                   <div className="tokenimg">
//                     <img
//                       src={selectedProject.imageSrc}
//                       alt={selectedProject.label}
//                       className="innerimg"
//                     />
//                   </div>
//                   <p className="tokenpara">{selectedProject.label}</p>
//                 </div>
//               )}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="15"
//                 height="8"
//                 viewBox="0 0 15 8"
//                 fill="none"
//                 style={{
//                   rotate: isDropdownOpen ? "180deg" : "0deg",
//                   transition: "rotate 0.3s ease-in-out",
//                 }}
//               >
//                 <path
//                   d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
//                   fill="black"
//                 />
//                 <path
//                   d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
//                   fill="black"
//                 />
//               </svg>
//             </Dropdown.Toggle>

//             <Dropdown.Menu>
//               <div className="tokenmain">
//                 {CLAIM_PROJECT_DATA.map((project, index) => (
//                   <div
//                     key={index}
//                     className="tokeninner"
//                     onClick={() => handleProjectSelect(project)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className="tokenimg">
//                       <img
//                         src={project.imageSrc}
//                         alt={project.label}
//                         className="innerimg"
//                       />
//                     </div>
//                     <p className="tokenpara">{project.label}</p>
//                   </div>
//                 ))}
//               </div>
//             </Dropdown.Menu>
//           </Dropdown>
//           <div className="maindownload">
//             <div className="downloadheadings">
//               <h6 className="downloadhead">CSV downloads</h6>
//               <p className="downloadpara">
//                 Include wallet addresses and transaction hashes.
//               </p>
//             </div>
//             <div className="parent-toggle-switch-custom tabletoggle">
//               <div className="custom-toggle">
//                 <input
//                   type="checkbox"
//                   className="checkbox"
//                   id="toggle-1"
//                   checked={toggle1}
//                   onChange={() => setToggle1(!toggle1)}
//                 />
//                 <label className="switch" htmlFor="toggle-1">
//                   <span className="slider"></span>
//                 </label>
//               </div>
//             </div>
//           </div>
//           <div className="bottombtns">
//             <button className="dullbtn" onClick={handleClose}>
//               Cancel
//             </button>
//             <button
//               onClick={() => {
//                 handleClose();
//                 handleShow1();
//               }}
//               className="greenbtn"
//             >
//               Add Client Dashboard
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>

//       <Modal
//         show={show1}
//         onHide={handleClose1}
//         className="creditmodal newcreditmodal newaddmodal"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Success</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="80"
//             height="81"
//             viewBox="0 0 80 81"
//             fill="none"
//             className="tickimg"
//           >
//             <path
//               d="M40 78.3947C60.9286 78.3947 77.8947 61.4286 77.8947 40.5C77.8947 19.5713 60.9286 2.60522 40 2.60522C19.0713 2.60522 2.10522 19.5713 2.10522 40.5C2.10522 61.4286 19.0713 78.3947 40 78.3947Z"
//               fill="#329879"
//             />
//             <path
//               d="M36.1262 54.8997C35.5788 54.8997 35.0315 54.6892 34.6525 54.2681L22.9473 42.5629C22.1051 41.7208 22.1051 40.4155 22.9473 39.5734C23.7894 38.7313 25.0946 38.7313 25.9367 39.5734L35.9999 49.6366L54.0209 26.8997C54.7367 25.9734 56.0841 25.8471 56.9683 26.5629C57.8946 27.2787 58.0209 28.626 57.3051 29.5102L37.8104 54.0997C37.4315 54.5629 36.8841 54.8576 36.2946 54.8997C36.2104 54.8997 36.1683 54.8997 36.1262 54.8997Z"
//               fill="#E2E9EC"
//             />
//           </svg>
//           <h6 className="successhead m-0">
//             Client Dashboard Successfully Added!
//           </h6>
//           <p className="successpara">
//             An email has been sent to the user. They will be able to set their
//             password and login to the admin panel using their new password.
//           </p>
//           <button onClick={handleClose1} className="closebtn">
//             Okay
//           </button>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Clientsdashboard;


// import React, { useState } from "react";
// import "./clientsdashboard.scss";
// import DataTable from "./DataTable/DataTable";
// import Modal from "react-bootstrap/Modal";
// import { Dropdown } from "react-bootstrap";
// import { useAddProject } from "../../../hooks/Refund/useAddProject_Credit";
// const Clientsdashboard = ({
//   isEditMode = false,
//   editData = null,
//   onEditComplete = () => {},
//   data,
//   getData,
// }) => {
//   const {
//     formData,
//     isDropdownOpen,
//     filteredProjects,
//     toggleDropdown,
//     handleProjectSelect,
//   } = useAddProject({ getData, data, isEditMode, editData, onEditComplete });

//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   const [show1, setShow1] = useState(false);

//   const handleClose1 = () => setShow1(false);
//   const handleShow1 = () => setShow1(true);
//   const [toggle1, setToggle1] = useState(false);
//   return (
//     <>
//       <section className="creditprojects">
//         <div className="custom-container">
//           <div className="topheadings">
//             <div className="leftheadings">
//               <p className="toppara">Premium Projects</p>
//               <h4 className="dashboardhead">Clients Dashboard</h4>
//             </div>
//             <button onClick={handleShow} className="projectbtn">
//               Add Client Dashboard
//             </button>
//           </div>

//           <DataTable />
//         </div>
//       </section>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         className="creditmodal newcreditmodal newaddmodal"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Client Dashboard</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <input type="text" placeholder="Name" className="modalinput" />
//           <input type="text" placeholder="User Email" className="modalinput" />
//           <Dropdown show={isDropdownOpen} onToggle={toggleDropdown}>
//             <Dropdown.Toggle
//               variant="success"
//               id="dropdown-basic"
//               style={{
//                 borderColor: isDropdownOpen ? "#329879" : "transparent",
//               }}
//               onClick={toggleDropdown}
//               disabled={isEditMode} // Disable dropdown in edit mode
//             >
//               {!formData.selectedProject ? (
//                 <>Project</>
//               ) : (
//                 <div className="tokeninner">
//                   <div className="tokenimg">
//                     <img
//                       src={formData.selectedProject.imageSrc}
//                       alt={formData.selectedProject.label}
//                       className="innerimg"
//                     />
//                   </div>
//                   <p className="tokenpara">{formData.selectedProject.label}</p>
//                 </div>
//               )}
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="15"
//                 height="8"
//                 viewBox="0 0 15 8"
//                 fill="none"
//                 style={{
//                   rotate: isDropdownOpen ? "180deg" : "0deg",
//                   transition: "rotate 0.3s ease-in-out",
//                 }}
//               >
//                 <path
//                   d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
//                   fill="black"
//                 />
//                 <path
//                   d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
//                   fill="black"
//                 />
//               </svg>
//             </Dropdown.Toggle>

//             <Dropdown.Menu>
//               <div className="tokenmain">
//                 {filteredProjects.map((project, index) => (
//                   <div
//                     key={index}
//                     className="tokeninner"
//                     onClick={() => handleProjectSelect(project)}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className="tokenimg">
//                       <img
//                         src={project.imageSrc}
//                         alt={project.label}
//                         className="innerimg"
//                       />
//                     </div>
//                     <p className="tokenpara">{project.label}</p>
//                   </div>
//                 ))}
//               </div>
//             </Dropdown.Menu>
//           </Dropdown>
//           <div className="maindownload">
//             <div className="downloadheadings">
//               <h6 className="downloadhead">CSV downloads</h6>
//               <p className="downloadpara">
//                 Include wallet addresses and transaction hashes.
//               </p>
//             </div>
//             <div className="parent-toggle-switch-custom tabletoggle">
//               <div className="custom-toggle">
//                 <input
//                   type="checkbox"
//                   className="checkbox"
//                   id="toggle-1"
//                   checked={toggle1}
//                   onChange={() => setToggle1(!toggle1)}
//                 />
//                 <label className="switch" htmlFor="toggle-1">
//                   <span className="slider"></span>
//                 </label>
//               </div>
//             </div>
//           </div>
//           <div className="bottombtns">
//             <button className="dullbtn" onClick={()=>{
//                 handleClose();
//             }}>
//               Cancel
//             </button>
//             <button onClick={()=>{
//                 handleClose();
//                 handleShow1();
//             }} className="greenbtn">
//               Add Client Dashboard
//             </button>
//           </div>
//         </Modal.Body>
//       </Modal>
//       <Modal
//         show={show1}
//         onHide={handleClose1}
//         className="creditmodal newcreditmodal newaddmodal"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Success</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="80"
//             height="81"
//             viewBox="0 0 80 81"
//             fill="none"
//             className="tickimg"
//           >
//             <path
//               d="M40 78.3947C60.9286 78.3947 77.8947 61.4286 77.8947 40.5C77.8947 19.5713 60.9286 2.60522 40 2.60522C19.0713 2.60522 2.10522 19.5713 2.10522 40.5C2.10522 61.4286 19.0713 78.3947 40 78.3947Z"
//               fill="#329879"
//             />
//             <path
//               d="M36.1262 54.8997C35.5788 54.8997 35.0315 54.6892 34.6525 54.2681L22.9473 42.5629C22.1051 41.7208 22.1051 40.4155 22.9473 39.5734C23.7894 38.7313 25.0946 38.7313 25.9367 39.5734L35.9999 49.6366L54.0209 26.8997C54.7367 25.9734 56.0841 25.8471 56.9683 26.5629C57.8946 27.2787 58.0209 28.626 57.3051 29.5102L37.8104 54.0997C37.4315 54.5629 36.8841 54.8576 36.2946 54.8997C36.2104 54.8997 36.1683 54.8997 36.1262 54.8997Z"
//               fill="#E2E9EC"
//             />
//           </svg>
//           <h6 className="successhead m-0">Client Dashboard Successfully Added!</h6>
//           <p className="successpara">An email has been sent to the user. They will be able to set their password and login to the admin panel using their new password.</p>
//           <button onClick={handleClose1} className="closebtn">
//        Okay
//           </button>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

// export default Clientsdashboard;
